<template>
  <CForm @submit="submit">
    <CModal :title="$t('jobLinkModal.title')" @close="close">
      <template #body>
        <CField v-if="targets.length > 0 || isComment" type="radio" v-model="target" :options="targets" :nullable="isComment" :required="!isComment">
          <template #nullOption>
            {{ $t('jobLinkModal.unlink') }}
          </template>
          <template #option="{ option }">
            {{ option.getTitle() }}
          </template>
        </CField>
        <CRemark v-if="targets.length === 0">{{ $t('jobLinkModal.noLinkableJobs') }}</CRemark>
      </template>
    </CModal>
  </CForm>
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue';
  import CModal from '@/general/components/CModal.vue';
  import CRemark from '@/shared/components/form/CRemark.vue';
  import CField from '@/shared/components/form/CField.vue';
  import CForm from '@/shared/components/form/CForm.vue';
  import { present } from '@/shared/utils/typescript';
  import JobType from '../constants/JobType';
  import Job from '../models/Job';
  import JobContext from '../models/JobContext';
  import JobMaster from '../models/JobMaster';
  import JobService from '../services/JobService';

  const props = defineProps<{
    context: JobContext;
    source: Job;
  }>();

  const emit = defineEmits<{ (e: 'close'): void }>();

  const sourceMaster = computed(() => present(props.context.getSummaryByJobId(props.source.id)));
  const isComment = computed(() => sourceMaster.value.type === JobType.COMMENT);
  const targets = computed(() => isComment.value ? props.context.getJobSummaries() : props.context.getCommentSummaries());

  const target = ref(getCurrentTarget());

  function getCurrentTarget(): JobMaster | null {
    if (isComment.value && sourceMaster.value.linkedJob) return props.context.getSummaryByJobId(sourceMaster.value.linkedJob.id) ?? null;
    return null;
  }

  async function submit() {
    if (isComment.value) {
      await JobService.linkComment(sourceMaster.value, target.value, props.context);
    } else if (target.value) {
      await JobService.linkComment(target.value, sourceMaster.value, props.context);
    }
    close();
  }

  function close() {
    emit('close');
  }
</script>